import { render } from "./EmailConsultPanelItem.vue?vue&type=template&id=52cfcd3e&scoped=true"
import script from "./EmailConsultPanelItem.vue?vue&type=script&lang=js"
export * from "./EmailConsultPanelItem.vue?vue&type=script&lang=js"

import "./EmailConsultPanelItem.vue?vue&type=style&index=0&id=52cfcd3e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cfcd3e"]])

export default __exports__